import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useFormFieldDef } from '../hooks/useFormFieldDef';

export const DateFormField = ({ fieldDef }) => {
  const { value, setValue, onBlur, error, helperText, label, disabled, variant } = useFormFieldDef(fieldDef);

  const dateValue = useMemo(() => {
    if (!value) return null;
    return dayjs(String(value), 'YYYYMMDD');
  }, [value]);

  const handleChange = (value) => {
    if (!value) {
      setValue(null);
      return;
    }

    const date = value.format('YYYYMMDD');
    setValue(date);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        disabled={disabled}
        label={label}
        sx={{ width: '100%' }}
        desktopModeMediaQuery="@media (min-width: 0px)" // Prevent mobile version
        slotProps={{
          actionBar: {
            actions: ['clear'],
          },
          textField: {
            fullWidth: true,
            variant: variant,
            helperText,
            error,
            onBlur,
          },
        }}
        value={dateValue}
        onChange={handleChange}
      />
    </LocalizationProvider>
  );
};
